import React, { memo } from 'react';
import './spinner.scss';
var Spinner = function (_a) {
    var size = _a.size, value = _a.value;
    return (React.createElement("div", { className: 'spinner' },
        React.createElement("sdds-spinner", { size: !size ? "md" : size }, value !== undefined && value !== null && (React.createElement("span", { className: 'percentage' },
            value,
            "%")))));
};
export default memo(Spinner);
